export const en = {
  creditsDomain: {
    dialogCreditsUser: {
      title: 'Credits',
      progress: {
        title: 'Remaining credits: {{credits}}',
        totalCredits: 'total credits: {{credits}}',
        nextRecharge: 'Next recharge: {{date}}',
      },
      howToWork: {
        title: 'How does it work?',
        description:
          'Every month you receive 1,000 credits to access courses, content, and activities. Every quarter, unused credits are automatically reset. ',
      },
    },
  },
};
